<template>

    <el-row>
      <el-col :span="24">

        <bar-chart :data="chart"
          thousands=","
          :label="legend"
          legend="left" />

      </el-col>
  </el-row>

</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [NumberMixins],


  props: {

    legend: {
      type: String,
      default: 'Active'
    },

    sharerData: {
      type: Array,
      required: true
    }

  },



  watch: {
    sharerData: function (value) {
      this.processData(value)
    }
  },


  methods: {

    processData (data) {

      this.sharers = []
      this.chart = []

      this.sharers = data

      if (this.sharers && this.sharers.length > 0) {

        for (var i = 0; i < this.sharers.length; i++) {
          this.chart.push([(this.sharers[i].shortName ? this.sharers[i].shortName : this.sharers[i].name), Number(Number(this.sharers[i].sitesActive).toFixed(2))])

          if (this.sharers[i].colourCode) {
            this.colours[i] = this.sharers[i].colourCode
          }
        }
      }
    }

  },



  data () {

    return {
      sharers: null,
      chart: null,
    }

  },

  created () {
    this.processData(this.sharerData)
  }
}
</script>



// WEBPACK FOOTER //
// SharersBarChart.vue?fdf3b59e